<div class="dialog-content" [@slideIn]>
    <div class="img-logo">
        <img height="70" width="70"
        src="/assets/images/avatar-autoarremate.png">
    </div>
    <h2>Acompanhe todas as negociações pelo app!</h2>
    <p>Com o app <strong>Auto Arremate | Exchange</strong> você recebe notificações em tempo real e envia propostas com mais rapidez.</p>
    <div class="button-container">
      <button type="button" class="btn btn-primary btn-pill confirm-button" (click)="redirectToAppStore()">ABRIR MEU APLICATIVO</button>
      <a class="close-dialog" (click)="closeDialog()">AGORA NÃO</a>
  </div>
  